import { useEffect } from "react";
import HeroBanner from "./components/HeroBanner";
import TrustBadges from "./components/TrustBadges";
import ShopByCollection from "./components/ShopByCollection";
import PhotoGallery from "./components/PhotoGallery";
import GiftBanner from "./components/GiftBanner";
import Newsletter from "./components/Newsletter";
import HowToOpenSpinner from "./components/HowToOpenSpinner";

export default function Home() {
  useEffect(() => {
    document.title = "SpinWorld.Us — Wind Spinners & Garden Art";
  }, []);
  return (
    <div className="bg-surface">
      <HeroBanner />
      <TrustBadges />
      <ShopByCollection />
      <HowToOpenSpinner />
      <PhotoGallery />
      <GiftBanner />
      <Newsletter />
    </div>
  );
}